import { createGtag } from "vue-gtag";

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter();

  // Get the correct GA_ID for each release level and domain
  let GA_MEASUREMENT_ID: string | null = null;
  const { releaseLevel, GTMTagId } = useRuntimeConfig().public;
  GA_MEASUREMENT_ID = GTMTagId;

  if (!GA_MEASUREMENT_ID) return;

  nuxtApp.vueApp.use(
    createGtag({
      tagId: GA_MEASUREMENT_ID,
      config: {
        params: {
          anonymize_ip: true,
        },
      },
      pageTracker: {
        router,
      },
      resource: {
        url: "https://www.googletagmanager.com/gtm.js",
      },
    }),
  );
});
